import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {PresenterProps, withPresenter} from '../../Support/with_presenter';
import {WorkoutSharePresenter} from './WorkoutSharePresenter';
import {PreviewWorkout} from '../../Models/PreviewWorkout';
import {Loader} from '../Components/Utils/Loader';
import {NetworkRequestStatus} from '../../Network/NetworkResult';
import {Full} from './Components/Full';
import {Preview} from './Components/Preview';
import {ErrorPlaceholder} from '../Components/Utils/ErrorPlaceholder';

interface OwnProps {
    id: number;
    hash: string;
    previewWorkout?: PreviewWorkout;
}

const WorkoutShareComponent: FunctionComponent<OwnProps & PresenterProps<WorkoutSharePresenter>> = observer(
    ({presenter}) => {
        if (presenter.title === null || presenter.fullWorkoutResult.status === NetworkRequestStatus.Loading) {
            return (
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <Loader />
                        </div>
                    </div>
                </div>
            );
        }

        if (presenter.fullWorkoutResult.status === NetworkRequestStatus.Error) {
            return (
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <ErrorPlaceholder large className="mt-5" />
                        </div>
                    </div>
                </div>
            );
        }

        if (presenter.fullWorkoutResult.status === NetworkRequestStatus.Success) {
            return (
                <Full
                    title={presenter.title}
                    fullWorkout={presenter.fullWorkoutResult.data}
                    geoTrackDownloadResult={presenter.geoTrackDownloadResult}
                />
            );
        }

        return <Preview title={presenter.title} />;
    },
);

export const WorkoutShare = withPresenter<WorkoutSharePresenter, OwnProps>(
    (props, component) =>
        new WorkoutSharePresenter(
            props.id,
            props.hash,
            props.previewWorkout || null,
            component.network.workouts,
            component.network.tracksDownload,
        ),
    WorkoutShareComponent,
);
